import {React, Component} from "react";

import "../css/App.css"


class Placeholder extends Component {
    render () {
        return <p className="small-text">Short any link with <a href="/" className="href">Timka ShortLink</a></p>
    }
}

export default Placeholder